import React, {useState} from 'react'
import {Button} from "antd";
import {getStockById} from "../../services/serviceStock";
import {getAllBrand} from "../../services/serviceBrand";
import {getAllCategory} from "../../services/serviceCategory";
import StockEdit from "./StockEdit";
import {getStockInformation} from "../../services/serviceInventory";

const StockEditContainer = ({stock, updater}) => {
    const [selectedBrand, setSelectedBrand] = useState('')
    const [brands, setBrands] = useState([])
    const [selectedCategory, setSelectedCategory] = useState('')
    const [categories, setCategories] = useState([])
    const [stockData, setStockData] = useState({})
    const [showModal, setShowModal] = useState(false)
    const [stockInventory, setStockInventory] = useState([])

    const handleEditClick = () => {
        getStockById(stock.id)
            .then(({data}) => {
                const stockData = {
                    stockId: stock.id,
                    stockName: data.name,
                    stockCode: data.code || null,
                    stockDescription: data.description,
                    stockQuantity: data.quantity,
                    stockUnit: data.unit,
                    stockPrice: data.price,
                    stockCurrency: data.currency,
                    stockThreshold: data.criticalThresdhold,
                    stockFirmCode: data.firmStockCode || null,
                    stockBrand: data.brand ? data.brand.code : null,
                    stockBrandId: data.brand ? data.brand.id : null,
                    stockCategoryId: data.category ? data.category.id : null,
                    stockCategory: data.category ? data.category.code : null
                }
                setStockData(stockData)
                setSelectedBrand(data.brand ? data.brand.id : null)
                setSelectedCategory(data.category ? data.category.id : null)
            })

        getAllBrand()
            .then(({data}) => {
                let brandsData = []
                data.forEach(item => {
                    let pushObj = {
                        value: item.id,
                        text: item.code
                    }
                    brandsData.push(pushObj)
                })
                setBrands(brandsData)
            })

        getAllCategory()
            .then(({data}) => {
                let categoryData = []
                data.forEach(item => {
                    let pushObj = {
                        value: item.id,
                        text: item.code
                    }
                    categoryData.push(pushObj)
                })
                setCategories(categoryData)
            })

        getStockInformation(stock.id)
            .then(({data}) =>{
                const inventory = data.map(item => {
                    return {
                        stock: {
                            id: item.stock.id
                        },
                        id: item.id,
                        warehouse: {
                            id: item.warehouse.id,
                            code: item.warehouse.code,
                            name: item.warehouse.name
                        },
                        quantity: item.quantity
                    }
                })
                setStockInventory(inventory)
            })

        toggleModalVisible()
    }
    const toggleModalVisible = () => setShowModal(!showModal)

    return (
        <React.Fragment>
            <Button type={'link'} onClick={() => handleEditClick()}> Güncelle </Button>
            {
                showModal ?
                    <StockEdit
                        brandList={brands}
                        isVisible={showModal}
                        updater={updater}
                        stock={stockData}
                        categoryList={categories}
                        modalCloser={toggleModalVisible}
                        stockInventory={stockInventory}
                    />
                    : null
            }
        </React.Fragment>
    )
}
export default StockEditContainer